;(() => {
  const ICON_SVG =
    '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="8.75" stroke="currentColor" stroke-width="1.5"/><path d="M10 6.5V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M10 13.5H10.01" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>'

  const SELECTOR_FORM = '[data-headsup-contact-form]'
  const SELECTOR_GROUP = '.headsup-contact__input-group'
  const SELECTOR_WRAPPER = '.headsup-contact__input-wrapper'
  const ERROR_CLASS = 'headsup-contact__input-group--error'

  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  const qs = (root, selector) => (root ? root.querySelector(selector) : null)

  const ensureIcon = wrapper => {
    if (!wrapper) {
      return null
    }
    let icon = qs(wrapper, '.headsup-contact__input-icon')
    if (!icon) {
      icon = document.createElement('span')
      icon.className = 'headsup-contact__input-icon'
      icon.setAttribute('aria-hidden', 'true')
      icon.innerHTML = ICON_SVG
      wrapper.appendChild(icon)
    }
    return icon
  }

  const ensureMessage = (group, input) => {
    if (!group) {
      return null
    }
    let messageEl = qs(group, '.headsup-contact__error-message')
    if (!messageEl) {
      messageEl = document.createElement('p')
      messageEl.className = 'headsup-contact__error-message'
      let id = input.id ? `${input.id}-error` : `headsup-contact-error-${Date.now()}`
      messageEl.id = id
      group.appendChild(messageEl)
    } else if (!messageEl.id) {
      const id = input.id ? `${input.id}-error` : `headsup-contact-error-${Date.now()}`
      messageEl.id = id
    }
    return messageEl
  }

  const clearError = input => {
    if (!input) return

    const group = input.closest(SELECTOR_GROUP)
    const wrapper = input.closest(SELECTOR_WRAPPER) || group

    if (group) {
      group.classList.remove(ERROR_CLASS)
      const messageEl = qs(group, '.headsup-contact__error-message')
      if (messageEl) {
        messageEl.remove()
      }
    }

    if (wrapper) {
      const icon = qs(wrapper, '.headsup-contact__input-icon')
      if (icon) {
        icon.remove()
      }
    }

    input.classList.remove('headsup-contact__input--with-icon', 'headsup-contact__textarea--with-icon')
    input.removeAttribute('aria-invalid')
    input.removeAttribute('aria-describedby')
  }

  const setError = (input, message) => {
    if (!input) return

    const group = input.closest(SELECTOR_GROUP)
    const wrapper = input.closest(SELECTOR_WRAPPER) || group
    if (!group) return

    group.classList.add(ERROR_CLASS)

    const icon = ensureIcon(wrapper)
    if (input.tagName === 'TEXTAREA') {
      input.classList.add('headsup-contact__textarea--with-icon')
    } else {
      input.classList.add('headsup-contact__input--with-icon')
    }

    const messageEl = ensureMessage(group, input)
    if (messageEl) {
      messageEl.textContent = message
      input.setAttribute('aria-describedby', messageEl.id)
    }

    input.setAttribute('aria-invalid', 'true')

    return { icon, messageEl }
  }

  const validateField = config => {
    const { input, requiredMessage, emailMessage, type } = config
    if (!input) return true

    clearError(input)

    const value = input.value.trim()
    if (!value) {
      setError(input, requiredMessage)
      return false
    }

    if (type === 'email' && !EMAIL_PATTERN.test(value)) {
      setError(input, emailMessage || requiredMessage)
      return false
    }

    return true
  }

  const attachFieldListeners = config => {
    const { input, type } = config
    if (!input) return

    const handler = () => {
      validateField(config)
    }

    input.addEventListener('input', handler)
    input.addEventListener('blur', handler)

    if (type === 'email') {
      input.addEventListener('change', handler)
    }
  }

  const initForm = form => {
    const nameInput = form.querySelector('#HeadsupContactName')
    const emailInput = form.querySelector('#HeadsupContactEmail')
    const messageInput = form.querySelector('#HeadsupContactMessage')

    const fieldConfigs = [
      {
        input: nameInput,
        type: 'text',
        requiredMessage: (nameInput && nameInput.dataset.requiredMessage) || 'Please fill out this field.',
      },
      {
        input: emailInput,
        type: 'email',
        requiredMessage: (emailInput && emailInput.dataset.requiredMessage) || 'Please fill out this field.',
        emailMessage: (emailInput && emailInput.dataset.emailMessage) || 'Please enter a valid email address.',
      },
      {
        input: messageInput,
        type: 'textarea',
        requiredMessage: (messageInput && messageInput.dataset.requiredMessage) || 'Please fill out this field.',
      },
    ]

    fieldConfigs.forEach(attachFieldListeners)

    form.addEventListener('submit', event => {
      let isValid = true
      let firstInvalidInput = null

      fieldConfigs.forEach(config => {
        const fieldValid = validateField(config)
        if (!fieldValid) {
          isValid = false
          if (!firstInvalidInput) {
            firstInvalidInput = config.input
          }
        }
      })

      if (!isValid) {
        event.preventDefault()
        event.stopPropagation()
        if (firstInvalidInput && typeof firstInvalidInput.focus === 'function') {
          firstInvalidInput.focus()
        }
      }
    })
  }

  const init = () => {
    const forms = document.querySelectorAll(SELECTOR_FORM)
    if (!forms.length) return
    forms.forEach(initForm)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()


